<template>
    <div class="span-like">
        <editor v-if="iseditmode == true && editortype == 'tinymce'" v-model="value" v-bind="$attrs" />
        <component v-if="iseditmode == false && editortype == 'tinymce'" :is="ComponentType" :style="$attrs.style" :class="Class" v-html="value">
        </component>
        <propertyiconeditor v-if="iseditmode == true && editortype == 'icon'" v-bind="$attrs" v-model:icon="Icon"></propertyiconeditor>
        <i v-if="iseditmode == false && editortype == 'icon' && Icon.Show " :class="IconClass" :style="{'color': Icon.Color, 'font-size': Icon.Size + 'px'}"></i>
    </div>
</template>

<script>
    import Editor from '@tinymce/tinymce-vue';
    import propertyiconeditor from '/src/components/propertyiconeditor.vue';

    export default {
        inheritAttrs: false,
        name: 'omnieditor',
        emits: ['update:icon'],
        components: {
            'editor': Editor,
            propertyiconeditor
        },
        props: {
            'icon': Object,
            'modelValue': {
                type: [Object, String], // Accepts either an object or a string
                default: () => ({})    // Default value is an empty object
            },
            iseditmode: Boolean,
            "editortype": String,
        },
        data() {
            return {
                DefaultTag: 'div',
                UsingDefaultTag: false,
            };
        },
        methods:
        {

        },
        computed:
        {
            Icon: {
                get() {
                    return this.icon;
                },
                set(value) {
                    this.$emit('update:icon', value);
                }
            },
            value: {
                get() {
                    return this.modelValue
                },
                set(value) {
                    this.$emit('update:modelValue', value)
                }
            },
            IconClass() {
                if (!this.Icon) {
                    return this.$attrs.class;
                }
                var c = this.$attrs.class + ` bi ${this.Icon.Icon}`;
                return c;
            },
            Class() {
                var c = this.$attrs.class;

                if (this.UsingDefaultTag) {
                    c += " span-like";
                }

                return c;
            },
            ComponentType() {
                var c = this.$attrs['tag-name'];
                if (!c) {
                    this.UsingDefaultTag = true;
                    c = this.DefaultTag;
                }
                return c;
            }
        },
        beforeMount: function () {

        },
        created: function () {
        },
        mounted: function () {
            
        },
        beforeUnmount: function () {

        }
    }
</script>

<style>
    div.span-like {
        display: inline; /* Make the div inline */
        padding: 0; /* Remove padding */
        margin: 0; /* Remove margin */
        border: none; /* Remove border */
        background: none; /* Remove background */
        /* Add any other styles as needed */
    }
</style>